/**
 * Returns position of match
 *
 * @param regex
 * @param startpos
 * @return {Number}
 */
String.prototype.regexIndexOf = function(regex, startpos) {
    var indexOf = this.substring(startpos || 0).search(regex);
    return (indexOf >= 0) ? (indexOf + (startpos || 0)) : indexOf;
};

/**
 * Returns last position of match
 *
 * @param regex
 * @param startpos
 * @return {number}
 */
String.prototype.regexLastIndexOf = function(regex, startpos) {
    regex = (regex.global) ? regex : new RegExp(regex.source, "g" + (regex.ignoreCase ? "i" : "") + (regex.multiLine ? "m" : ""));
    if(typeof (startpos) == "undefined") {
        startpos = this.length;
    } else if(startpos < 0) {
        startpos = 0;
    }
    var stringToWorkWith = this.substring(0, startpos + 1);
    var lastIndexOf = -1;
    var nextStop = 0;
    while((result = regex.exec(stringToWorkWith)) != null) {
        lastIndexOf = result.index;
        regex.lastIndex = ++nextStop;
    }
    return lastIndexOf;
};

/**
 * Capitalize first letter
 * @param string
 * @returns {string}
 */
function ucfirst(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Size of object - number of items
 *
 * @param {object} obj
 * @returns {number}
 */
Object.size = function(obj) {
	var size = 0, key;
	for (key in obj) {
		if (obj.hasOwnProperty(key)) size++;
	}
	return size;
};

/**
 * Abstract method error
 * @throws Error
 */
function abstractMethod() {
	throw new Error('This method is abstract, therefore must be redeclared in descendant!');
}

/**
 * Inheritance
 *
 * @param parentClassOrObject
 * @returns {Function}
 */
Function.prototype.inheritsFrom = function(parentClassOrObject)
{
	if (typeof parentClassOrObject.constructor === 'function') {
		this.prototype = new parentClassOrObject;
		this.prototype.constructor = this;
		this.prototype.parent = parentClassOrObject.prototype;
	} else {
		this.prototype = parentClassOrObject;
		this.prototype.constructor = this;
		this.prototype.parent = parentClassOrObject;
	}

	return this;
};

/**
 * Converts array into object where key is the same as value
 * @param {Array} array
 * @returns {object}
 */
function arrayToObjectEqualKeys(array)
{
	return array.reduce(function(o, val) { o[val] = val; return o; }, {});
}

/**
 * Return variable value or use default one
 *
 * @param variable
 * @param defaultValue
 * @returns
 */
function makeOptional(variable, defaultValue){

	if( typeof variable !== 'undefined' ){
		return variable;
	} else {
		return defaultValue;
	}

}

/**
 * Format file size
 *
 * @param {int} size in bits
 * @returns {String}
 */
function formatFilesize(size, space)
{
	space = typeof space === 'undefined' ? '&nbsp;' : space;
	var suffixes = ['B', 'kB', 'MB', 'GB', 'TB', 'PB'];
	var index = 0;

	do {
		index = index + 1;
		size = size / 1024;
	} while (size > 980);

	return (Math.round(size * 10) / 10).toFixed(1) + space + suffixes[index];

}

/**
 * Prepend leading zeroes
 *
 * @param n číslo
 * @param length počet míst
 * @returns string
 */
function leadingZero(n, length){

	n = n + '';

	for (var i = n.length; i < length; i++){
		n = '0'+n;
	}
	return n;
}

/**
 * Czech natural comparation method for sorting
 *
 * @param string item1
 * @param string item2
 * @returns -1, 0 , 1
 */
var czechCompare = (function() {
	var chars = "aáäàãâbcćčdďeéěëèêfghiíïìîjklĺľmnńňñoóôòõöőpqrŕřsśštťuúùůüũûvwxyýzźž" ;
	chars = chars.replace(/./g, function($0) { return $0 + $0.toUpperCase();});
	var sorted = chars.split("").sort().join("");
	var map = {};

	for (var i = 0; i < chars.length; ++i)
		if (chars.charAt(i) != sorted.charAt(i))
			map[chars.charAt(i)] = sorted.charAt(i);

	return function(a, b) {
		for (var i = 0, len = Math.min(a.length, b.length); i < len; ++i) {
			var c, c1 = a.charAt(i), c2 = b.charAt(i);

			if (c = map[c1]) c1 = c;
			if (c = map[c2]) c2 = c;
			if (c1 < c2) return -1;
			if (c1 > c2) return 1;
		}

		return a.length != b.length ? a.length - b.length : 0;
	};
})();

/**
 * Is given value a number
 *
 * @param number
 * @returns {Boolean}
 */
function isNumber(n) {
	return !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Creates Date in UTC zone from given string or timestamp
 *
 * @param {String} date
 * @param [{String} format]
 * @returns {Date}
 */
function dateFromUTC(date, format)
{
	if (typeof format !== 'undefined') {
		date = Date.parseExact(date, format);
	}

	date = new Date(date);
	return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
}

/**
 * Return random item of array
 *
 * @param {array} array
 * @returns {mixed}
 */
function array_rand(array)
{
	if (!$.isArray(array) || array.length < 1) {
		throw new TypeError('Invalid array for array_rand!');
	}

	return (array[Math.round((array.length - 1) * Math.random())]);
}

/**
 * Generate UUID
 *
 * @return {string}
 */
function uuid() {
	var d = new Date().getTime();
	var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		var r = (d + Math.random()*16)%16 | 0;
		d = Math.floor(d/16);
		return (c=='x' ? r : (r&0x3|0x8)).toString(16);
	});
	return uuid;
}

/**
 * @type {function}
 */
window.uniqid = uuid;

/**
 * Scroll windows to given offset
 *
 * @param {number} value
 * @param {number} duration = 400
 * @param {string} easing = 'swing'
 * @param {function} callback
 */
function scrollToAnimated(value, duration, easing, callback)
{
	if (typeof easing === 'undefined') {
		easing = 'swing';
	}

	if (typeof duration === 'undefined') {
		duration = 400;
	}

	$('html, body').stop().animate(
		{
			scrollTop: value
		}, {
			duration: duration,
			easing: easing,
			complete: function () {
				$(window).trigger('scroll');
				if (typeof callback === 'function') {
					callback();
				}
			}
		}
	);

}

/**
 * Scroll window to element
 *
 * @param {string|jquery} element
 * @param {number} offset = 0
 * @param {number} duration = 400
 * @param {string} easing = 'swing'
 * @param {function} callback
 */
function scrollToElementAnimated(element, offset, duration, easing, callback)
{
	element = $(element);

	if (!element.length) {
		return;
	}

	if (!isNumber(offset)) {
		offset = 0;
	}

	var pos = element.offset().top + offset;

	scrollToAnimated(pos, duration, easing, callback);
}

/**
 * @param {string} text
 * @return {string}
 */
function translate(text)
{
	if (typeof translations === 'object' && typeof translations[text] !== 'undefined') {
		return translations[text];
	} else {
		return text;
	}
}

/**
 * Default alert function override
 *
 * @param {string} message
 * @param {string} title
 * @param {string} icon
 * @param {function} onClose
 */
window.alert = function(message, title, icon, onClose)
{
	if (typeof icon === 'undefined') {
		icon = 'warning';
	}

	if (typeof message === 'undefined' || message.length < 1) {
		throw new TypeError('Alert requires message!');
	}

	if (typeof title === 'undefined' || title.length < 1) {
		title = translate('Zpráva');
	}
 
	$('#alert h3').text(title);
    $('#alert p').html('<i class="material-icons left">' + icon + '</i>' + message);
    
    $('#alert').modal({
        onCloseEnd : function () {
            if (typeof onClose === 'function') {
                onClose();
            }
            $('#alert').modal('destroy');
        }
    }).modal('open');
};

/**
 * Fallback for flash message to toast
 * @param message
 * @param status
 */
window.createFlashMessage = function (message, status)
{
	var colorClass = undefined;

	if (status === 'success') {
		colorClass = 'light-green darken-1';
	} else if (status === 'error') {
		colorClass = 'red darken-1';
	} else if (status === 'warning') {
		colorClass = 'yellow darken-1';
	}

	M.toast({
        html : message,
        classes : colorClass,
        displayLength : 3000
    });
};

function fixMaterializeIButton(parent)
{
	$(parent).find('i.btn').not('ifixed').each(function () {

		var i = $(this);
		var subbutton = i.children('input[type=button], input[type=submit]');

		if (subbutton.length) {
			i.click(function (e) {
				if ($(e.target).is(i)) {
					e.preventDefault();
					e.stopPropagation();
					subbutton.click();
				}
			});
		}

		i.addClass('ifixed');

	});

}

/**
 * Get MD5 of string
 * @returns {String}
 */
String.prototype.md5 = function ()
{
	return md5(this.toString());
};

/**
 * Decode string from base64 encoded string
 * @returns {String}
 */
String.prototype.fromBase64 = function ()
{

	var encodedData = this.toString();

	var decodeUTF8string = function (str) {
		return decodeURIComponent(str.split('').map(function (c) {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
		}).join(''))
	};

	if (typeof window !== 'undefined') {
		if (typeof window.atob !== 'undefined') {
			return decodeUTF8string(window.atob(encodedData))
		}
	} else {
		return new Buffer(encodedData, 'base64').toString('utf-8')
	}
	var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	var o1;
	var o2;
	var o3;
	var h1;
	var h2;
	var h3;
	var h4;
	var bits;
	var i = 0;
	var ac = 0;
	var dec = '';
	var tmpArr = [];
	if (!encodedData) {
		return encodedData
	}
	encodedData += '';
	do {
		h1 = b64.indexOf(encodedData.charAt(i++));
		h2 = b64.indexOf(encodedData.charAt(i++));
		h3 = b64.indexOf(encodedData.charAt(i++));
		h4 = b64.indexOf(encodedData.charAt(i++));
		bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;
		o1 = bits >> 16 & 0xff;
		o2 = bits >> 8 & 0xff;
		o3 = bits & 0xff;
		if (h3 === 64) {
			tmpArr[ac++] = String.fromCharCode(o1)
		} else if (h4 === 64) {
			tmpArr[ac++] = String.fromCharCode(o1, o2)
		} else {
			tmpArr[ac++] = String.fromCharCode(o1, o2, o3)
		}
	} while (i < encodedData.length);
	dec = tmpArr.join('');

	return decodeUTF8string(dec.replace(/\0+$/, ''))
};

/**
 * @param {Array} array
 * @param {boolean} useValueAsKey
 * @returns {Object}
 */
function arrayToObject(array, useValueAsKey)
{
	var res = {};

	$.map(array, function (value, i) { res[(useValueAsKey === true ? value : i)] = value; });

	return res;
}